<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted } from "vue";
import { TelegramClient } from "@/websocket/Client";
import { useRouter } from "vue-router";
const router = useRouter();
// 在应用启动时建立连接
onMounted(async () => {
  try {
    const client = TelegramClient.getInstance();
    await client.connect();
    console.log("WebSocket 连接已建立");
  } catch (error) {
    console.error("WebSocket 连接失败:", error);
  }

  localStorage.setItem("isLoggedIn", "false");
  router.push("/login");
});

// 在应用关闭时断开连接
onUnmounted(() => {
  const client = TelegramClient.getInstance();
  client.disconnect();
});

const clearSession = () => {
  localStorage.removeItem("session");
  localStorage.removeItem("isLoggedIn");
  localStorage.removeItem("username");
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
